// Minimal container entry. LAW is a federation remote; this entry only exists so
// rsbuild can build the MF container. Browsing http://localhost:3200/ directly
// renders the placeholder in ./index (the shell is consumed via ./AppShell).
//
// This file MUST contain nothing but the dynamic import below. react/react-dom
// are Module Federation shared singletons declared without `eager: true`, so the
// MF runtime resolves them asynchronously. A static top-level import of either
// one here forces the runtime down the synchronous `loadShareSync` path, which is
// only legal for eager shares, and the container dies on startup with
// "[ Federation Runtime ]: Invalid loadShareSync function call #RUNTIME-006".
// The dynamic import is the async boundary that lets shares resolve first.
//
// Do not "fix" a recurrence by setting eager: true on react — that bundles a
// second React into this remote and defeats the singleton.
import('./index');
